<template lang="html">
  <div class="TablePlayer">
    <div
      :class="[
        'TablePlayer__table',
        detailsVisible ? 'TablePlayer__table--active' : '',
      ]"
    >
      <router-link
        :to="`players/${player.id}`"
        class="TableColumn TableColumn--flex clickable md-w-90"
      >
        <profile-pic v-show="false" :src="player.photo_url" :alt="player.name" :size="40" />
        <div class="ml-8">{{ player.name }}</div>
      </router-link>
      <div class="TableColumn TableColumn--medium TablePlayer__events-col" v-if="showEventsColumn">
        <div v-if="playerEvents.length > 0" class="TablePlayer__events-inline">
          <router-link
            :to="{ name: 'dashboard', params: { id: playerEvents[0].id } }"
            class="TablePlayer__event-tag"
          ><tag-item>{{ playerEvents[0].name }}</tag-item></router-link>
          <tag-item
            v-if="playerEvents.length > 1"
            class="TablePlayer__event-count"
            @click.native="toggleDetails"
          >+{{ playerEvents.length - 1 }}</tag-item>
        </div>
        <span v-else>-</span>
      </div>
      <div class="TableColumn TableColumn--short">
        <rating
          :rating="
            player.average_rating[0] ? player.average_rating[0].rating : null
          "
        ></rating>
      </div>
      <div class="TableColumn TableColumn--medium">
        <span v-if="player.preffered_positions" class="TablePlayer__positions">
          <tag-item
            v-for="position in player.preffered_positions"
            :key="position.id"
            >{{ position.short_name }}</tag-item
          >
        </span>
        <span v-else>
          Player haven't defined preffered positions.
        </span>
      </div>
      <div class="TableColumn TableColumn--short">
        <action
          icon="files"
          grey
          v-if="hasNotes"
          @click.native="toggleDetails"
        ></action>
      </div>
      <div class="TableColumn TableColumn--short">
        {{ player.birthday | moment('D/M/YYYY') }}
      </div>
      <div
        :class="['TableColumn TableColumn--extend md-w-10']"
        @click="toggleDetails"
      >
        <svg-icon icon="more"></svg-icon>
      </div>
    </div>
    <transition name="slide">
      <div v-if="detailsVisible">
        <section class="TablePlayer__content">
          <div class="TablePlayer__content__block" v-if="playerEvents.length > 0">
            <h1 class="text-md text-bold">Events</h1>
            <div class="TablePlayer__events-list">
              <router-link
                v-for="event in playerEvents"
                :key="event.id"
                :to="{ name: 'dashboard', params: { id: event.id } }"
                class="TablePlayer__event-tag"
              ><tag-item>{{ event.name }}</tag-item></router-link>
            </div>
          </div>
          <div class="TablePlayer__content__block" v-if="hasNotes">
            <h1 class="text-md text-bold">Selector's notes</h1>
            <Note
              v-for="note in player.player_notes"
              :key="note.id"
              :note="note"
            />
          </div>
          <div class="TablePlayer__content__block" v-else>
            <h1 class="text-md text-bold">Selector's notes</h1>
            Player doesn't have any notes
          </div>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
  import Note from '@/partials/Note'
  export default {
    name: 'TablePlayer',
    components: { Note },
    props: {
      player: {
        type: Object,
        required: true,
      },
      showEventsColumn: {
        type: Boolean,
        default: false,
      },
    },
    data: function() {
      return {
        detailsVisible: false,
      }
    },
    methods: {
      toggleDetails() {
        this.detailsVisible = !this.detailsVisible
      },
    },
    computed: {
      hasNotes() {
        return this.player.player_notes && this.player.player_notes.length > 0
      },
      playerEvents() {
        return this.player.player_events || []
      },
    },
  }
</script>

<style scoped>
  .TablePlayer__events-col {
    display: flex;
    align-items: center;
  }
  .TablePlayer__events-inline {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .TablePlayer__event-tag {
    text-decoration: none;
    display: inline-block;
    max-width: 140px;
  }
  .TablePlayer__event-tag >>> .Tag__content {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .TablePlayer__event-tag:hover >>> .Tag {
    opacity: 0.8;
  }
  .TablePlayer__event-count {
    cursor: pointer;
  }
  .TablePlayer__events-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 8px;
  }
  @media (max-width: 768px) {
    .TablePlayer__events-col {
      display: none;
    }
  }
</style>
